import { jsxs as C, jsx as o } from "react/jsx-runtime";
import { forwardRef as g } from "react";
import d from "./components/content/Icon/Icon.js";
import "styled-components";
import { typographyBodySizeMap as M, typographyBodyLineHeightMap as L } from "./styles/typography/typography.js";
import "./components/layout/Stack/Stack.js";
import u from "./components/layout/Box/Box.js";
import { styledWithConfig as y } from "./components/layout/Box/utils.js";
import "./index-CZ8zjHGv.js";
import f from "./components/layout/Center/Center.js";
import "./context/WindowSize/Dimensions.js";
import "lodash-es";
import "./components/layout/Columns/ColumnsContext.js";
import { useThemeInMode as T } from "./context/theme/hooks.js";
import v from "./hooks/useDelayOnPropChange/index.js";
import "./hooks/link/index.js";
import "@material/material-color-utilities";
import "react-select";
import "react-select/async";
import "./components/typography/Text/Text.js";
import "./context/Text.js";
import "./context/Typography.js";
import "./components/controls/Toggle/CustomCheckbox.js";
import "focus-trap-react";
import h from "./components/controls/IconButton/hooks/useGetIconButtonStyles.js";
import { avatarSizeToStylesMap as I } from "./components/content/Avatar/consts.js";
import x from "./components/content/Avatar/components/SecondaryCircle.js";
import "./components/content/Logo/consts.js";
import j from "./components/controls/Button/utils/getBorderStyleProps.js";
import w from "./components/controls/Button/utils/getMiscStyleProps.js";
import A from "./components/controls/Button/utils/getPaddingStyleProps.js";
import { sizeToTypographyBodySizeMap as $ } from "./components/controls/Button/utils/sizeToTypographyBodySizeMap.js";
import D from "./components/controls/Button/utils/useButtonColorStyleProps.js";
import { sizeMap as G } from "./components/controls/IconButton/consts.js";
const H = {
  standard: "large",
  small: "medium"
};
function N(e) {
  const { children: n, loading: p, size: t } = e, r = v(p), i = T();
  return /* @__PURE__ */ C(f, { children: [
    /* @__PURE__ */ o(u, { position: "absolute", children: r && /* @__PURE__ */ o(
      d,
      {
        accessibilityLabel: "Loading...",
        iconName: i.icons.loader,
        size: H[t]
      }
    ) }),
    /* @__PURE__ */ o(u, { transform: r ? "scale(0)" : void 0, children: n })
  ] });
}
const O = y("button");
function bo({
  onClick: e,
  children: n,
  tone: p = "primary",
  fill: t = "filled",
  size: r = "standard",
  disabled: i = !1,
  loading: s = !1,
  width: a = ["100%", void 0],
  fillHeight: m = !1,
  accessibilityLabel: l,
  type: c
}) {
  const S = w({
    width: a,
    fillHeight: m,
    accessibilityLabel: l,
    disabled: i,
    loading: s
  }), B = D({
    fill: t,
    tone: p,
    disabled: i
  }), P = j(t), z = A(r), b = $[r];
  return /* @__PURE__ */ o(
    O,
    {
      onClick: e,
      disabled: i || s,
      ...S,
      ...B,
      ...P,
      ...z,
      ...M[b],
      ...L.large,
      type: c,
      children: /* @__PURE__ */ o(N, { loading: s, size: r, children: n })
    }
  );
}
const R = y("button"), Co = g(
  ({
    iconName: e,
    onClick: n,
    accessibilityLabel: p,
    size: t = "large",
    tone: r = "primary",
    disabled: i = !1,
    blend: s = !1,
    fill: a = "filledTonal"
  }, m) => {
    const l = h({
      tone: r,
      disabled: i,
      blend: s,
      size: t,
      fill: a
    }), { iconSize: c } = G[t];
    return /* @__PURE__ */ o(
      R,
      {
        padding: "none",
        onClick: n,
        "aria-label": p ?? void 0,
        disabled: i,
        ref: m,
        ...l,
        children: /* @__PURE__ */ o(f, { children: /* @__PURE__ */ o(d, { accessibilityLabel: null, iconName: e, size: c }) })
      }
    );
  }
), W = y("button"), Mo = g(
  ({
    iconName: e,
    onClick: n,
    accessibilityLabel: p,
    disabled: t = !1,
    tone: r = "primary",
    avatarSize: i,
    type: s
  }, a) => {
    const m = h({
      tone: r,
      disabled: t,
      blend: !1,
      fill: "filledTonal"
    }), {
      secondaryCircleSize: l,
      secondaryCirclePadding: c
    } = I[i];
    return /* @__PURE__ */ o(x, { size: l, children: /* @__PURE__ */ o(
      W,
      {
        padding: c,
        onClick: n,
        "aria-label": p ?? void 0,
        disabled: t,
        ref: a,
        ...m,
        width: "100%",
        height: "100%",
        type: s,
        children: /* @__PURE__ */ o(f, { children: /* @__PURE__ */ o(d, { accessibilityLabel: null, iconName: e, size: "fill" }) })
      }
    ) });
  }
);
export {
  Mo as A,
  bo as B,
  Co as I,
  N as a
};
